import React, { useMemo } from 'react';
import { IssueReportState } from './IssueReportState';
import { issueContextFromApiError, type IssueReportContext } from '../../platform/support/issueReport';

interface ErrorStateProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
  issue_context: IssueReportContext;
  customer_id?: number;
  error?: unknown;
  auto_log?: boolean;
}

/**
 * v3 load-failure state: user message, optional retry, WhatsApp support, and automatic local issue log.
 */
export const ErrorState: React.FC<ErrorStateProps> = ({
  title,
  message,
  onRetry,
  issue_context,
  customer_id,
  error,
  auto_log,
}) => {
  const merged_context = useMemo(() => {
    if (!error) {
      return issue_context;
    }
    return issueContextFromApiError(issue_context.page, issue_context.issue, error, {
      api_endpoint: issue_context.api_endpoint,
      http_method: issue_context.http_method,
      kind: issue_context.kind,
    });
  }, [error, issue_context]);

  return (
    <IssueReportState
      issue_context={merged_context}
      title={title}
      message={message}
      onRetry={onRetry}
      customer_id={customer_id}
      auto_log={auto_log}
    />
  );
};

export default ErrorState;
